import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BioentitySearchInput from 'inventory/BioentitySearchInput';
import {FieldType, SchemaField} from 'schemas/fields/SchemaFieldConstants';
import DateFilterForm from 'search/filters/base/DateFilterForm';
import DropdownFilterForm from 'search/filters/base/DropdownFilterForm';
import {FilterStyle} from 'search/filters/base/FilterFormConstants';
import ItemSearchInputFilterForm from 'search/filters/base/ItemSearchInputFilterForm';
import SecondaryFilterDropdownSkeleton from 'search/filters/base/SecondaryFilterDropdownSkeleton';
import TextAreaFilterForm from 'search/filters/base/TextAreaFilterForm';
import TextValueFilterForm from 'search/filters/base/TextValueFilterForm';
import TwoInputFilterForm from 'search/filters/base/TwoInputFilterForm';
import SchemaFieldStandardFilterForm from 'search/filters/SchemaFieldStandardFilterForm';
import {FieldFilter, FilterKey, Operator} from 'search/SearchConstants';
import {
  SCHEMA_FIELD_BATCH_LINK_WITH_LINEAGE,
  SCHEMA_FIELD_BIOENTITY_LINK,
  SCHEMA_FIELD_DATE,
  SCHEMA_FIELD_ENTRY_LINK,
  SCHEMA_FIELD_FLOAT,
  SCHEMA_FIELD_INTEGER,
  SCHEMA_FIELD_LONG_TEXT,
  SCHEMA_FIELD_SELECTOR,
  SCHEMA_FIELD_STORABLE_LINK,
  SCHEMA_FIELD_TEXT,
  SCHEMA_FIELD_TEXT_2,
} from 'test/fixtures/registry/TagSchemaFixtures'; // eslint-disable-line import-x/no-restricted-paths
import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';
import {ButtonSize} from 'ui-library/buttons/Button';
import * as Headers from 'ui-library/Headers';
import PaddedBorderedCell from 'ui-library/internal/PaddedBorderedCell';

interface FilterFormGuidelinesState {
  primaryDateFilterFormToDate: string;
  primaryDateFilterFormFromDate: string;
  secondaryDateFilterFormToDate: string;
  secondaryDateFilterFormKey: FilterKey;
  secondaryDateFilterFormFromDate: string;

  primaryDropdownFilterFormValue: Array<string>;
  secondaryDropdownFilterFormKey: FilterKey;
  secondaryDropdownFilterFormValue: Array<string>;

  primaryItemSearchInputFilterFormOperator: Operator;
  primaryItemSearchInputFilterFormValue: Array<Item>;
  secondaryItemSearchInputFilterFormKey: FilterKey;
  secondaryItemSearchInputFilterFormOperator: Operator;
  secondaryItemSearchInputFilterFormValue: Array<Item>;

  primaryTwoInputFilterFormName: string;
  primaryTwoInputFilterFormValue: string;
  secondaryTwoInputFilterFormKey: FilterKey;
  secondaryTwoInputFilterFormName: string;
  secondaryTwoInputFilterFormValue: string;

  primarySchemaFieldFilterFormOperator: Operator;
  primarySchemaFieldFilterFormSchemaField: SchemaField | null;
  primarySchemaFieldFilterFormFilter: FieldFilter;
  secondarySchemaFieldFilterFormKey: FilterKey;
  secondarySchemaFieldFilterFormOperator: Operator;
  secondarySchemaFieldFilterFormSchemaField: SchemaField | null;
  secondarySchemaFieldFilterFormFilter: FieldFilter;

  primaryTextValueFilterFormOperator: Operator;
  primaryTextValueFilterFormValue: string;
  secondaryTextValueFilterFormKey: FilterKey;
  secondaryTextValueFilterFormOperator: Operator;
  secondaryTextValueFilterFormValue: string;

  primaryInvalidFilterFormOperator: Operator;
  primaryInvalidFilterFormValue: string;
  secondaryInvalidFilterFormKey: FilterKey;
  secondaryInvalidFilterFormOperator: Operator;
  secondaryInvalidFilterFormValue: string;

  primaryTextAreaFilterFormValue: string;
  secondaryTextAreaFilterFormValue: string;
  secondaryTextAreaFilterFormKey: FilterKey;

  isSecondaryDropdown1Open: boolean;
  isSecondaryDropdown2Open: boolean;
}

export default class FilterFormGuidelines extends React.Component<{}, FilterFormGuidelinesState> {
  override state: FilterFormGuidelinesState = {
    primaryDateFilterFormToDate: '',
    primaryDateFilterFormFromDate: '',
    secondaryDateFilterFormToDate: '',
    secondaryDateFilterFormKey: FilterKey.AUTHOR,
    secondaryDateFilterFormFromDate: '',

    primaryDropdownFilterFormValue: [],
    secondaryDropdownFilterFormKey: FilterKey.AUTHOR,
    secondaryDropdownFilterFormValue: [],

    primaryItemSearchInputFilterFormOperator: Operator.IS,
    primaryItemSearchInputFilterFormValue: [],
    secondaryItemSearchInputFilterFormKey: FilterKey.AUTHOR,
    secondaryItemSearchInputFilterFormOperator: Operator.IS,
    secondaryItemSearchInputFilterFormValue: [],

    primaryTwoInputFilterFormName: '',
    primaryTwoInputFilterFormValue: '',
    secondaryTwoInputFilterFormKey: FilterKey.AUTHOR,
    secondaryTwoInputFilterFormName: '',
    secondaryTwoInputFilterFormValue: '',

    // TODO: This should be fixed
    // eslint-disable-next-line react/no-unused-state
    primarySchemaFieldFilterFormOperator: Operator.IS,
    // eslint-disable-next-line react/no-unused-state
    primarySchemaFieldFilterFormSchemaField: null,
    primarySchemaFieldFilterFormFilter: {
      key: FilterKey.SCHEMA_FIELD,
      operator: Operator.INCLUDES_TEXT,
      fieldId: 'tsf_12345',
      fieldType: FieldType.TEXT,
      value: '',
    },
    secondarySchemaFieldFilterFormKey: FilterKey.AUTHOR,
    // TODO: This should be fixed
    // eslint-disable-next-line react/no-unused-state
    secondarySchemaFieldFilterFormOperator: Operator.IS,
    // eslint-disable-next-line react/no-unused-state
    secondarySchemaFieldFilterFormSchemaField: null,
    secondarySchemaFieldFilterFormFilter: {
      key: FilterKey.SCHEMA_FIELD,
      operator: Operator.INCLUDES_TEXT,
      fieldId: 'tsf_12345',
      fieldType: FieldType.TEXT,
      value: '',
    },

    primaryTextValueFilterFormOperator: Operator.IS,
    primaryTextValueFilterFormValue: '',
    secondaryTextValueFilterFormKey: FilterKey.AUTHOR,
    secondaryTextValueFilterFormOperator: Operator.IS,
    secondaryTextValueFilterFormValue: '',

    primaryInvalidFilterFormOperator: Operator.IS,
    primaryInvalidFilterFormValue: '',
    secondaryInvalidFilterFormKey: FilterKey.AUTHOR,
    secondaryInvalidFilterFormOperator: Operator.IS,
    secondaryInvalidFilterFormValue: '',

    primaryTextAreaFilterFormValue: '',
    secondaryTextAreaFilterFormValue: '',
    secondaryTextAreaFilterFormKey: FilterKey.AUTHOR,

    isSecondaryDropdown1Open: false,
    isSecondaryDropdown2Open: false,
  };

  _handleToggleSecondaryDropdown1 = (isOpen: boolean): void => {
    this.setState({isSecondaryDropdown1Open: isOpen});
  };

  _handleToggleSecondaryDropdown2 = (isOpen: boolean): void => {
    this.setState({isSecondaryDropdown2Open: isOpen});
  };

  override render(): JSX.Element {
    return (
      <div className="u-spacing">
        <Headers.Header2>Filters</Headers.Header2>
        <div>
          <a href="https://projects.invisionapp.com/d/#/console/13658196/310035130/preview">
            https://projects.invisionapp.com/d/#/console/13658196/310035130/preview
          </a>
        </div>

        <div className="u-spacing-top">
          <Headers.Title>FilterForm Components</Headers.Title>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Forms</PaddedBorderedCell>
                <PaddedBorderedCell>Primary</PaddedBorderedCell>
                <PaddedBorderedCell>Secondary</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              <tr>
                <PaddedBorderedCell>
                  <code>TextValueFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TextValueFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="TextValueFilterForm - primary"
                      filterStyle={FilterStyle.PRIMARY}
                      onChangeOperator={(operator: Operator) => {
                        console.log(`Updated operator to: ${operator}`);
                        this.setState({primaryInvalidFilterFormOperator: operator});
                      }}
                      onChangeValue={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({primaryInvalidFilterFormValue: value});
                      }}
                      operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                      selectedOperator={this.state.primaryInvalidFilterFormOperator}
                      initialValue={this.state.primaryInvalidFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TextValueFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryInvalidFilterFormKey: filterKey});
                      }}
                      onChangeOperator={(operator: Operator) => {
                        console.log(`Updated operator to: ${operator}`);
                        this.setState({secondaryInvalidFilterFormOperator: operator});
                      }}
                      onChangeValue={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({secondaryInvalidFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove TextValueFilter!');
                      }}
                      operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                      selectedFilterKey={this.state.secondaryInvalidFilterFormKey}
                      selectedOperator={this.state.secondaryInvalidFilterFormOperator}
                      initialValue={this.state.secondaryInvalidFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>TextValueFilterForm</code> (invalid)
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TextValueFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="TextValueFilterForm - primary"
                      filterStyle={FilterStyle.PRIMARY}
                      onChangeOperator={(operator: Operator) => {
                        console.log(`Updated operator to: ${operator}`);
                        this.setState({primaryTextValueFilterFormOperator: operator});
                      }}
                      onChangeValue={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({primaryTextValueFilterFormValue: value});
                      }}
                      operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                      selectedOperator={this.state.primaryTextValueFilterFormOperator}
                      initialValue={this.state.primaryTextValueFilterFormValue}
                      invalidMessage="Something's wrong!"
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TextValueFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryTextValueFilterFormKey: filterKey});
                      }}
                      onChangeOperator={(operator: Operator) => {
                        console.log(`Updated operator to: ${operator}`);
                        this.setState({secondaryTextValueFilterFormOperator: operator});
                      }}
                      onChangeValue={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({secondaryTextValueFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove TextValueFilter!');
                      }}
                      operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                      selectedFilterKey={this.state.secondaryTextValueFilterFormKey}
                      selectedOperator={this.state.secondaryTextValueFilterFormOperator}
                      initialValue={this.state.secondaryTextValueFilterFormValue}
                      invalidMessage="Something's wrong!"
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>TwoInputFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TwoInputFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="TwoInputFilterForm - primary"
                      filterStyle={FilterStyle.PRIMARY}
                      onChangeValueOne={(value: string) => {
                        console.log(`Updated name to: ${value}`);
                        this.setState({primaryTwoInputFilterFormName: value});
                      }}
                      onChangeValueTwo={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({primaryTwoInputFilterFormValue: value});
                      }}
                      valueOnePlaceholder="name"
                      valueTwoPlaceholder="value"
                      initialValueOne={this.state.primaryTwoInputFilterFormName}
                      initialValueTwo={this.state.primaryTwoInputFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TwoInputFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      valueOnePlaceholder="name"
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryTwoInputFilterFormKey: filterKey});
                      }}
                      onChangeValueOne={(value: string) => {
                        console.log(`Updated name to: ${value}`);
                        this.setState({primaryTwoInputFilterFormName: value});
                      }}
                      onChangeValueTwo={(value) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({primaryTwoInputFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove MultiValueFilter!');
                      }}
                      valueTwoPlaceholder="value"
                      selectedFilterKey={this.state.secondaryTwoInputFilterFormKey}
                      initialValueOne={this.state.secondaryTwoInputFilterFormName}
                      initialValueTwo={this.state.secondaryTwoInputFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>DateFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <DateFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="DateFilterForm - primary"
                      toDate={this.state.primaryDateFilterFormToDate}
                      filterStyle={FilterStyle.PRIMARY}
                      onChangeToDate={(value: string) => {
                        console.log(`Updated end date to: ${value}`);
                        this.setState({primaryDateFilterFormToDate: value});
                      }}
                      onChangeFromDate={(value: string) => {
                        console.log(`Updated start date to: ${value}`);
                        this.setState({primaryDateFilterFormFromDate: value});
                      }}
                      fromDate={this.state.primaryDateFilterFormFromDate}
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <DateFilterForm
                      buttonSize={ButtonSize.SMALL}
                      toDate={this.state.secondaryDateFilterFormToDate}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      onChangeToDate={(value: string) => {
                        console.log(`Updated end date to: ${value}`);
                        this.setState({secondaryDateFilterFormToDate: value});
                      }}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryDateFilterFormKey: filterKey});
                      }}
                      onChangeFromDate={(value: string) => {
                        console.log(`Updated start date to: ${value}`);
                        this.setState({secondaryDateFilterFormFromDate: value});
                      }}
                      onRemove={() => {
                        console.log('Remove DateFilter!');
                      }}
                      selectedFilterKey={this.state.secondaryDateFilterFormKey}
                      fromDate={this.state.secondaryDateFilterFormFromDate}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>DropdownFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <DropdownFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="DropdownFilterForm"
                      filterStyle={FilterStyle.PRIMARY}
                      isMulti={true}
                      onChangeValue={(value: Array<string>) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({primaryDropdownFilterFormValue: value});
                      }}
                      optionDatas={[
                        {name: 'Option 1', value: 'opt_1'},
                        {name: 'Option 2', value: 'opt_2'},
                        {name: 'Option 3', value: 'opt_3'},
                      ]}
                      value={this.state.primaryDropdownFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <DropdownFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      isMulti={false}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryDropdownFilterFormKey: filterKey});
                      }}
                      onChangeValue={(value: Array<string>) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({secondaryDropdownFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove DropdownFilter!');
                      }}
                      optionDatas={[
                        {name: 'Option 1', value: 'opt_1'},
                        {name: 'Option 2', value: 'opt_2'},
                        {name: 'Option 3', value: 'opt_3'},
                      ]}
                      selectedFilterKey={this.state.secondaryDropdownFilterFormKey}
                      value={this.state.secondaryDropdownFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>ItemSearchInputFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <ItemSearchInputFilterForm
                    buttonSize={ButtonSize.SMALL}
                    dropdownToggleText="Selected"
                    filterStyle={FilterStyle.PRIMARY}
                    itemSearchInputClass={BioentitySearchInput}
                    onChangeOperator={(operator: Operator) => {
                      console.log(`Updated operator to: ${operator}`);
                      this.setState({primaryItemSearchInputFilterFormOperator: operator});
                    }}
                    onChangeValue={(value: Array<Item>) => {
                      console.log(`Updated value to: ${value}`);
                      this.setState({primaryItemSearchInputFilterFormValue: value});
                    }}
                    operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                    selectedOperator={this.state.primaryItemSearchInputFilterFormOperator}
                    value={this.state.primaryItemSearchInputFilterFormValue}
                  />
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <ItemSearchInputFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="Selected"
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      itemSearchInputClass={BioentitySearchInput}
                      onChangeOperator={(operator: Operator) => {
                        console.log(`Updated operator to: ${operator}`);
                        this.setState({secondaryItemSearchInputFilterFormOperator: operator});
                      }}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryItemSearchInputFilterFormKey: filterKey});
                      }}
                      onChangeValue={(value: Array<Item>) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({secondaryItemSearchInputFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove DropdownFilter!');
                      }}
                      operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                      selectedFilterKey={this.state.secondaryItemSearchInputFilterFormKey}
                      selectedOperator={this.state.secondaryItemSearchInputFilterFormOperator}
                      value={this.state.secondaryItemSearchInputFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>
                  <code>TextAreaFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <TextAreaFilterForm
                    buttonSize={ButtonSize.SMALL}
                    dropdownToggleText="TextAreaFilterForm - primary"
                    filterStyle={FilterStyle.PRIMARY}
                    onChangeValue={(value: string) => {
                      console.log(`Updated value to: ${value}`);
                      this.setState({primaryTextAreaFilterFormValue: value});
                    }}
                    placeholder="value"
                    initialValue={this.state.primaryTextAreaFilterFormValue}
                  />
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <TextAreaFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      onChangeFilterKey={(filterKey: FilterKey) => {
                        console.log(`Updated filter key to: ${filterKey}`);
                        this.setState({secondaryTextAreaFilterFormKey: filterKey});
                      }}
                      onChangeValue={(value: string) => {
                        console.log(`Updated value to: ${value}`);
                        this.setState({secondaryTextAreaFilterFormValue: value});
                      }}
                      onRemove={() => {
                        console.log('Remove DropdownFilter!');
                      }}
                      placeholder="value"
                      selectedFilterKey={this.state.secondaryTextAreaFilterFormKey}
                      initialValue={this.state.secondaryTextAreaFilterFormValue}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="u-spacing-top">
          <Headers.Title>Filter Components</Headers.Title>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Filters</PaddedBorderedCell>
                <PaddedBorderedCell>Primary</PaddedBorderedCell>
                <PaddedBorderedCell>Secondary</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              <tr>
                <PaddedBorderedCell>
                  <code>SchemaFieldFilterForm</code>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <SchemaFieldStandardFilterForm
                      buttonSize={ButtonSize.SMALL}
                      dropdownToggleText="Field"
                      filter={this.state.primarySchemaFieldFilterFormFilter}
                      filterStyle={FilterStyle.PRIMARY}
                      onChangeFilter={(filter: FieldFilter) => {
                        console.log(`Updated filter to ${filter}`);
                        this.setState({primarySchemaFieldFilterFormFilter: filter});
                      }}
                      schemaFields={[
                        SCHEMA_FIELD_DATE,
                        SCHEMA_FIELD_FLOAT,
                        SCHEMA_FIELD_INTEGER,
                        SCHEMA_FIELD_LONG_TEXT,
                        SCHEMA_FIELD_TEXT,
                        SCHEMA_FIELD_TEXT_2,
                        SCHEMA_FIELD_ENTRY_LINK,
                        SCHEMA_FIELD_BATCH_LINK_WITH_LINEAGE,
                        SCHEMA_FIELD_BIOENTITY_LINK,
                        SCHEMA_FIELD_STORABLE_LINK,
                        SCHEMA_FIELD_SELECTOR,
                      ]}
                    />
                  </div>
                </PaddedBorderedCell>
                <PaddedBorderedCell>
                  <div className={css(styles.formCell)}>
                    <SchemaFieldStandardFilterForm
                      buttonSize={ButtonSize.SMALL}
                      filterGroups={[
                        {
                          filterOptions: [
                            {filterKey: FilterKey.AUTHOR},
                            {filterKey: FilterKey.BARCODES},
                            {filterKey: FilterKey.NAMES},
                            {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                          ],
                        },
                      ]}
                      filterStyle={FilterStyle.SECONDARY}
                      filter={this.state.secondarySchemaFieldFilterFormFilter}
                      onChangeFilter={(filter: FieldFilter) => {
                        console.log(`Updated filter to ${filter}`);
                        this.setState({secondarySchemaFieldFilterFormFilter: filter});
                      }}
                      onRemove={() => {
                        console.log('Remove SchemaFieldFilterForm!');
                      }}
                      schemaFields={[
                        SCHEMA_FIELD_DATE,
                        SCHEMA_FIELD_FLOAT,
                        SCHEMA_FIELD_INTEGER,
                        SCHEMA_FIELD_LONG_TEXT,
                        SCHEMA_FIELD_TEXT,
                        SCHEMA_FIELD_TEXT_2,
                        SCHEMA_FIELD_ENTRY_LINK,
                        SCHEMA_FIELD_BATCH_LINK_WITH_LINEAGE,
                        SCHEMA_FIELD_BIOENTITY_LINK,
                        SCHEMA_FIELD_STORABLE_LINK,
                        SCHEMA_FIELD_SELECTOR,
                      ]}
                      selectedFilterKey={this.state.secondarySchemaFieldFilterFormKey}
                    />
                  </div>
                </PaddedBorderedCell>
              </tr>
            </tbody>
          </table>
          <div className="u-spacing-top">
            <span className="u-spacing-right">
              <SecondaryFilterDropdownSkeleton
                buttonSize={ButtonSize.SMALL}
                hasFilterErrors={false}
                secondaryFilterNodes={[]}
                onAddFilter={() => {
                  console.log('Add filter');
                }}
                isOpen={this.state.isSecondaryDropdown1Open}
                onToggle={this._handleToggleSecondaryDropdown1}
              />
            </span>
            <span>
              <SecondaryFilterDropdownSkeleton
                buttonSize={ButtonSize.SMALL}
                hasFilterErrors={false}
                secondaryFilterNodes={[
                  <TextValueFilterForm
                    buttonSize={ButtonSize.SMALL}
                    filterGroups={[
                      {
                        filterOptions: [
                          {filterKey: FilterKey.AUTHOR},
                          {filterKey: FilterKey.BARCODES},
                          {filterKey: FilterKey.NAMES},
                          {filterKey: FilterKey.SCHEMA_FIELD, extraProps: {schemaFields: []}},
                        ],
                      },
                    ]}
                    filterStyle={FilterStyle.SECONDARY}
                    onChangeFilterKey={(filterKey: FilterKey) => {
                      console.log(`Updated filter key to: ${filterKey}`);
                      this.setState({secondaryTextValueFilterFormKey: filterKey});
                    }}
                    onChangeOperator={(operator: Operator) => {
                      console.log(`Updated operator to: ${operator}`);
                      this.setState({secondaryTextValueFilterFormOperator: operator});
                    }}
                    onChangeValue={(value: string) => {
                      console.log(`Updated value to: ${value}`);
                      this.setState({secondaryTextValueFilterFormValue: value});
                    }}
                    onRemove={() => {
                      console.log('Remove TextValueFilter!');
                    }}
                    operators={[Operator.IS, Operator.CONTAINS, Operator.IS_ONE_OF]}
                    selectedFilterKey={this.state.secondaryTextValueFilterFormKey}
                    selectedOperator={this.state.secondaryTextValueFilterFormOperator}
                    initialValue={this.state.secondaryTextValueFilterFormValue}
                  />,
                ]}
                onAddFilter={() => {
                  console.log('Add filter');
                }}
                isOpen={this.state.isSecondaryDropdown2Open}
                onToggle={this._handleToggleSecondaryDropdown2}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  formCell: {
    width: 400,
  },
});
